var map = {
	"./AlertIcon.vue": "5376",
	"./ArrowDarkIcon.vue": "c4fa",
	"./ArrowIcon.vue": "35c8",
	"./ArrowcurvedIcon.vue": "6472",
	"./ArrowdownIcon.vue": "b6cc",
	"./ArrowupIcon.vue": "ab03",
	"./ClockIcon.vue": "1b60",
	"./CloseIcon.vue": "e944",
	"./DollarIcon.vue": "963f",
	"./DotsIcon.vue": "abc1",
	"./EditIcon.vue": "ef6a",
	"./EyeIcon.vue": "42d1",
	"./EyeoffIcon.vue": "8dd7",
	"./FileIcon.vue": "3152",
	"./FileWhiteIcon.vue": "64ce",
	"./FilterIcon.vue": "c3b0",
	"./FindIcon.vue": "0279",
	"./IndicatorIcon.vue": "5971",
	"./InfoIcon.vue": "c822",
	"./LockedIcon.vue": "5399",
	"./LogoutIcon.vue": "7a16",
	"./MappinIcon.vue": "c973",
	"./MappindarkIcon.vue": "95e2",
	"./MinusIcon.vue": "8734",
	"./NotificationIcon.vue": "b870",
	"./OrderboxIcon.vue": "347c",
	"./OrderemptyIcon.vue": "cdc0",
	"./PenIcon.vue": "7d6c",
	"./PencilIcon.vue": "ddfc",
	"./PlusIcon.vue": "57bc",
	"./PrimeOrderIcon.vue": "1eef",
	"./ProfileIcon.vue": "1372",
	"./PurpleCloseIcon.vue": "0cad",
	"./RedarrowIcon.vue": "9484",
	"./RightArrowIcon.vue": "01e8",
	"./SearchIcon.vue": "fdd9",
	"./SettingsIcon.vue": "4a15",
	"./StoreIcon.vue": "fba0",
	"./SuccessIcon.vue": "f158",
	"./TimeIcon.vue": "3db0",
	"./TrashIcon.vue": "e4a8",
	"./TruckIcon.vue": "dbc7",
	"./UnlockedIcon.vue": "3b75",
	"./UserIcon.vue": "7938",
	"./WarningIcon.vue": "5a87",
	"./WhatsappIcon.vue": "5e9e",
	"./WhitePlusIcon.vue": "6ab2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54de";